export default {"src":"/_next/static/media/logo.820a06f7.svg","height":85,"width":140};